<!-- <p-button
  *appRights="[permissions.createPlatformUser]"
  label="Adaugă utilizator"
  icon="pi pi-plus"
  class="mb-2"
  (click)="createUser()"
></p-button> -->

<form [formGroup]="filtersForm" class="grid align-items-end row-gap-1 mt-2">
  <div class="col-12 lg:col-4">
    <span class="font-bold block mb-2">Interval căutare</span>
    <p-calendar
      inputId="interval"
      styleClass="w-full"
      dateFormat="dd/mm/yy"
      selectionMode="range"
      formControlName="interval"
      [showIcon]="true"
      [showOnFocus]="true"
      [placeholder]="'Data de la'"
      [panelStyle]="{
        'height': '439px'
      }"
    ></p-calendar>
  </div>

  <div class="col-12 lg:col-4">
    <span class="font-bold block mb-1">Identificator factură</span>
    <p-iconField class="w-full" iconPosition="right">
      @if (filtersForm.get("identifier")?.value?.length > 0) {
        <p-inputIcon
          styleClass="pi pi-times cursor-pointer"
          (click)="patchFilters({
            identifier: ''
          })"
        />
      }
      <input
        pInputText
        class="w-full"
        placeholder="Identificator factură"
        formControlName="identifier"
      />
    </p-iconField>
  </div>
</form>

<p-table
  styleClass="p-datatable-sm w-full"
  paginatorPosition="both"
  currentPageReportTemplate="{first} - {last} din {totalRecords} facturi"
  dataKey="identifier"
  [first]="(filtersForm.value.page - 1) * filtersForm.value.pageSize"
  [expandedRowKeys]="expandedRows()"
  [totalRecords]="totalCount()"
  [lazy]="true"
  [value]="data()"
  [rows]="filtersForm.get('pageSize')?.value"
  [paginator]="true"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[25, 50, 100]"
  (onPage)="pageChanged($event)"
  (onRowExpand)="expandRow($event.data)"
  (onRowCollapse)="collapseRow($event.data)"
>
  <ng-template pTemplate="header">
    @if (loading()) {
      <tr>
        <td colspan="8">
          <p-progressBar
            mode="indeterminate"
            styleClass="w-full"
            [style]="{ height: '6px' }"
          ></p-progressBar>
        </td>
      </tr>
    }
    <tr>
      @if (hasAccessTo([permissions.viewBillingInvoiceDetails])) {
        <th></th>
      }
      <th class="white-space-nowrap">Companie</th>
      <th class="white-space-nowrap">Detalii factură</th>
      <th class="white-space-nowrap">Interval</th>
      <th class="white-space-nowrap">Sumă</th>
      <th class="white-space-nowrap">Zonă</th>
      <th class="white-space-nowrap">Status e-factura</th>
      <th class="white-space-nowrap"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-invoice let-expanded="expanded">
    <tr>
      @if (hasAccessTo([permissions.viewBillingPreInvoiceDetails])) {
        <td class="py-0">
          <p-button
            pRipple
            type="button"
            size="small"
            [pRowToggler]="invoice"
            [text]="true"
            [rounded]="true"
            [plain]="true"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          />
        </td>
      }
      <td>
        <small class="text-gray-400 text-2xs">
          {{ invoice.identifier }}
        </small>
        <p class="m-0 font-bold">{{ invoice.billingDetails.fiscalName }}</p>
        <small class="m-0">
          CUI {{ invoice.billingDetails.identificationCode }},
          Reg. com. {{ invoice.billingDetails.tradeRegisterNumber }}
        </small><br>
        <small class="text-gray-600">
          {{ formatAddress(invoice.billingDetails.address) }}
        </small>
        @if (invoice.billingDetails.note) {
          <br>
          <small>
            Notă: {{ invoice.billingDetails.note }}
          </small>
        }
        @if (invoice.billingDetails?.contact?.email?.length) {
          <br>
          <small>
            Email: {{ invoice.billingDetails.contact.email }}
          </small>
        }
      </td>
      <td class="white-space-nowrap">
        <p class="m-0">{{ invoice.serial }}{{ invoice.number }}</p>
        <p class="m-0">{{ invoice.date | date:"dd/MM/yyyy"}}</p>
      </td>
      <td>
        <p class="m-0 white-space-nowrap">
          @if (invoice?.period?.start && invoice?.period?.end) {
            {{ invoice.period.start | date: "dd/MM/yyyy" }} -
            {{ invoice.period.end | date: "dd/MM/yyyy" }}
          } @else {
            <span class="text-gray-400">Necunoscut</span>
          }
        </p>
      </td>
      <td>
        <b class="m-0 text-xl">{{ invoice.grossAmount | currency: "RON" }}</b><br>
        <small class="text-gray-600">Valoare TVA: {{ invoice.vatAmount | currency: "RON" }}</small><br>
        <small class="text-gray-600">Valoare netă: {{ invoice.netAmount | currency: "RON" }}</small>
      </td>
      <td>
        {{ invoice.zone.name }}
      </td>
      <td>
        <p-tag [severity]="getStatusSeverity(invoice.eInvoicing?.status)" styleClass="white-space-nowrap">
          <div class="flex align-items-center gap-2 text-xs">
            <span class="flex align-items-center justify-content-center text-white border-circle z-1">
              @switch (invoice.eInvoicing?.status) {
                @case ("QUEUED") {
                  <span class="pi pi-clock text-xs"></span>
                }

                @case ("UPLOADED") {
                  <span class="pi pi-check-circle text-xs"></span>
                }

                @case ("SUCCESS") {
                  <span class="pi pi-check-circle text-xs"></span>
                }

                @case ("FAILURE") {
                  <span class="pi pi-times text-xs"></span>
                }

                @case ("PROCESSED") {
                  <span class="pi pi-verified"></span>
                }

                @default {
                  <span class="pi pi-question-circle text-xs"></span>
                }
              }
            </span>
            <div class="flex flex-column">
              {{ $any(statusesTranslationsList())[invoice.eInvoicing?.status] || "Neîncărcat" }}
            </div>
          </div>
        </p-tag>
        @if (invoice.eInvoicing?.uploadIndex) {
          <p class="m-0 text-xs white-space-nowrap">
            Index e-factura:
            <span class="inline-flex align-items-center">
              <span class="text-primary hover:underline cursor-pointer">
                <b
                  [appCopy]="invoice.eInvoicing?.uploadIndex"
                  (click)="showSuccessToast('Index copiat cu succes')"
                >{{ invoice.eInvoicing?.uploadIndex }}</b>
              </span>
            </span>
          </p>
        }
      </td>
      <td>
        <div class="flex align-items-center justify-content-end gap-2">
          @if (hasMenuItems(invoice)) {
            <button
              pButton
              class="py-2 px-3 text-xs white-space-nowrap"
              size="small"
              label="Descarcă fișiere"
              icon="pi pi-download"
              severity="primary"
              [loading]="downloading()[invoice.identifier]"
              (click)="invoiceMenu.toggle($event)"
            ></button>
          }
        </div>
      </td>
    </tr>
    <p-menu #invoiceMenu appendTo="body" [popup]="true"
            [model]="getInvoiceMenuItems(invoice)" [tabindex]="undefined" (onBlur)="menuClosed(invoice)" />
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-invoice>
    @let invoiceData = invoicesData()[invoice.identifier];
    @if (invoiceData) {
      <tr>
        <td colspan="8">
          <p-table styleClass="p-datatable-stripped my-2" [value]="invoiceData.items">
            <ng-template pTemplate="header">
              <tr>
                <th>Denumire serviciu / produs</th>
                <th class="text-center">Cantitate</th>
                <th class="text-center">TVA</th>
                <th class="text-right">Preț unitar (RON)</th>
                <th class="text-right">Valoare TVA (RON)</th>
                <th class="text-right">Total (RON)</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
              <tr>
                <td>{{ item.name }}</td>
                <td class="text-center">{{ item.quantity }}</td>
                <td class="text-center">{{ item.taxPercentage }}%</td>
                <td class="text-right">{{ item.unitPrice}}</td>
                <td class="text-right">{{ item.taxAmount }}</td>
                <td class="text-right">{{ getItemTotal(item) }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr>
                <td colspan="3">
                  <b>TOTAL</b>
                </td>
                <td class="text-right">{{ getTotalWithoutVAT(invoiceData) | currency: "RON" }}</td>
                <td class="text-right">{{ getTotalVAT(invoiceData) | currency: "RON" }}</td>
                <td class="text-right">{{ getTotalToPay(invoiceData) | currency: "RON" }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptyMesssage">
              @if (!loading()) {
                <tr>
                  <td colspan="6">
                    <p class="text-gray-400 text-center text-lg font-bold">Nu există date.</p>
                  </td>
                </tr>
              }
            </ng-template>
          </p-table>

          @if (detailsToggled()[invoice.identifier]) {
            <p-divider></p-divider>

            <p-table styleClass="p-datatable-stripped" [value]="invoiceData.metadata[invoiceMetadataKeys.BOXES_COUNTS_BY_TYPE]!">
              <ng-template pTemplate="header">
                <tr>
                  <th>Tip cutie</th>
                  <th>Număr folosiri</th>
                  <th>Număr discount</th>
                  <th class="text-right">Valoare totală cutii (RON)</th>
                  <th class="text-right">Valoare discount (RON)</th>
                  <th class="text-right">Valoare finală (RON)</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-metadata let-rowIndex="rowIndex">
                <tr>
                  <td>{{ metadata.boxType.name }}</td>
                  <td>{{ metadata.total.count }}</td>
                  <td>{{ metadata.discount.count }}</td>
                  <td class="text-right">{{ metadata.total.amount }}</td>
                  <td class="text-right">{{ metadata.discount.amount }}</td>
                  <td class="text-right">{{ metadata.final.amount }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <tr>
                  @let totals = calculateBoxTotal(invoiceData.metadata.boxes_counts_by_type);
                  <td class="font-bold">TOTAL</td>
                  <td class="font-bold">{{ totals.count }}</td>
                  <td class="font-bold">{{ totals.discountCount }}</td>
                  <td class="font-bold text-right">{{ totals.amount.toFixed(2) | currency: "RON" }}</td>
                  <td class="font-bold text-right">{{ totals.discountAmount.toFixed(2) | currency: "RON" }}</td>
                  <td class="font-bold text-right">{{ totals.finalAmount.toFixed(2) | currency: "RON" }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptyMesssage">
                @if (!loading()) {
                  <tr>
                    <td colspan="6">
                      <p class="text-gray-400 text-center text-lg font-bold">Nu există date.</p>
                    </td>
                  </tr>
                }
              </ng-template>
            </p-table>

            <p-divider></p-divider>

            <p-table styleClass="p-datatable-sm" [value]="invoiceData.metadata[invoiceMetadataKeys.EXTRA_SERVICES_COUNT]!">
              <ng-template pTemplate="header">
                <tr>
                  <th>Tip serviciu</th>
                  <th>Număr folosiri</th>
                  <th>Valoare totală (RON)</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-service>
                <tr>
                  <td>{{ service.kind }}</td>
                  <td>{{ service.count }}</td>
                  <td>{{ service.amount | currency: "RON" }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                @if (!loading()) {
                  <tr>
                    <td class="text-center" colspan="5">
                      <b class="text-gray-400">Fară servicii extra.</b>
                    </td>
                  </tr>
                }
              </ng-template>
            </p-table>

            <p-divider></p-divider>

            @let reportedRequestsTotal = (invoiceData.metadata.pick_up_request_reported ?? 0) +
            (invoiceData.metadata.drop_off_request_reported ?? 0);
            <p-table styleClass="p-datatable-striped" [value]="[1]">
              <ng-template pTemplate="header">
                <tr>
                  <th rowspan="2">Tip</th>
                  <th colspan="2" class="text-center border-left-1">Luna precedentă</th>
                  <th colspan="2" class="text-center border-x-1">Luna curentă</th>
                </tr>
                <tr>
                  <th class="text-center border-left-1">AWB-uri</th>
                  <th class="text-center border-left-1">Cutii folosite</th>
                  <th class="text-center border-left-1">AWB-uri</th>
                  <th class="text-center border-x-1">Cutii folosite</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body">
                <tr>
                  <td>Pickup</td>
                  <td class="text-center">{{ invoiceData.metadata.boxes_count_pick_up_previous_month?.unique }}</td>
                  <td class="text-center">{{ invoiceData.metadata.boxes_count_pick_up_previous_month?.total }}</td>
                  <td class="text-center">{{ invoiceData.metadata.boxes_count_pick_up_current_month?.unique }}</td>
                  <td class="text-center">{{ invoiceData.metadata.boxes_count_pick_up_current_month?.total }}</td>
                </tr>
                <tr>
                  <td>DropOff</td>
                  <td class="text-center">{{ invoiceData.metadata.boxes_count_drop_off_previous_month?.unique }}</td>
                  <td class="text-center">{{ invoiceData.metadata.boxes_count_drop_off_previous_month?.total }}</td>
                  <td class="text-center">{{ invoiceData.metadata.boxes_count_drop_off_current_month?.unique }}</td>
                  <td class="text-center">{{ invoiceData.metadata.boxes_count_drop_off_current_month?.total }}</td>
                </tr>
                <tr>
                  <td>
                    Reportate
                  </td>
                  <td class="text-center">0</td>
                  <td class="text-center">0</td>
                  <td class="text-center">{{ reportedRequestsTotal }}</td>
                  <td class="text-center">{{ reportedRequestsTotal }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer">
                <!-- Pre invoice data variable declared before the table -->
                @let lastMonthAWBTotal = (invoiceData.metadata.boxes_count_pick_up_previous_month?.unique ?? 0) + (invoiceData.metadata.boxes_count_drop_off_previous_month?.unique ?? 0);
                @let lastMonthUsedBoxesTotal = (invoiceData.metadata.boxes_count_pick_up_previous_month?.total ?? 0) + (invoiceData.metadata.boxes_count_drop_off_previous_month?.total ?? 0);
                @let currentMonthAWBTotal = (invoiceData.metadata.boxes_count_pick_up_current_month?.unique ?? 0) + (invoiceData.metadata.boxes_count_drop_off_current_month?.unique ?? 0) + reportedRequestsTotal;
                @let currentMonthUsedBoxesTotal = (invoiceData.metadata.boxes_count_pick_up_current_month?.total ?? 0) + (invoiceData.metadata.boxes_count_drop_off_current_month?.total ?? 0) + reportedRequestsTotal;
                <tr>
                  <td>TOTAL</td>
                  <td class="text-center">{{ lastMonthAWBTotal }}</td>
                  <td class="text-center">{{ lastMonthUsedBoxesTotal }}</td>
                  <td class="text-center">{{ currentMonthAWBTotal }}</td>
                  <td class="text-center">{{ currentMonthUsedBoxesTotal }}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                @if (!loading()) {
                  <tr>
                    <td class="text-center text-gray-400" colspan="5">
                      Nu există date
                    </td>
                  </tr>
                }
              </ng-template>
            </p-table>
          } @else {
            @if (invoiceData.metadata) {
              <button
                pButton
                label="Vezi detalii"
                size="small"
                (click)="toggleDetailsFor(invoice)"
              ></button>
            }
          }
        </td>
      </tr>
    } @else {
      <tr>
        <td colspan="8">
          <p-skeleton height="10rem" styleClass="w-full"></p-skeleton>
        </td>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="emptymessage">
    @if (!loading()) {
      <tr>
        <td colspan="8">
          <p class="text-gray-400 text-center text-lg font-bold">Nu există facturi.</p>
        </td>
      </tr>
    }
  </ng-template>
</p-table>
